import React from "react";
import PageHeader from "@/components/PageHeader";
import { Construction } from "lucide-react";

const ModulePlaceholder = ({ tag, title, description, items = [], accent = "cyan" }) => (
  <div className="p-6 max-w-7xl">
    <PageHeader tag={tag} title={title} subtitle={description} accent={accent} />

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
      {items.map((it) => (
        <div key={it.label} className="csx-card p-5">
          <div className={`text-[10px] uppercase tracking-[0.3em] text-${accent === "pink" ? "fuchsia" : "cyan"}-400`}>
            {it.label}
          </div>
          <div className="font-display text-3xl mt-2 text-slate-100">{it.value}</div>
          <div className="text-xs text-slate-400 mt-2">{it.note}</div>
        </div>
      ))}
    </div>

    <div className="csx-card p-8 text-center">
      <Construction className="h-10 w-10 text-amber-400 mx-auto mb-3" />
      <div className="text-sm uppercase tracking-[0.3em] text-amber-300">Phase II Module</div>
      <p className="text-sm text-slate-400 mt-3 max-w-xl mx-auto">
        Full operator UI for this module is queued for the next release. The underlying engines
        ({title}) are integrated and feeding data into Operations Dashboard, SOC Copilot,
        and the AI Cyber Twin.
      </p>
    </div>
  </div>
);

export default ModulePlaceholder;
